import React, { useState, useEffect } from "react";
import axiosClient from "../../axios"; // Your axios instance

const PriceDiscountComponent = () => {
  const [price, setPrice] = useState("");
  const [commission, setCommission] = useState("");
  const [tax, setTax] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    // Load existing value from backend on component mount
    const fetchExisting = async () => {
      try {
        const response = await axiosClient.get("/api/option/pricing");
        if (response.data?.option_value) {
          const data = JSON.parse(response.data.option_value);
          setPrice(data.price || "");
          setCommission(data.commission || "");
          setTax(data.tax || "");
        }
      } catch (err) {
        console.error("Error loading saved data", err);
      } finally {
        setInitialLoading(false);
      }
    };
    fetchExisting();
  }, []);

  const calculateFinalPrice = () => {
    const p = parseFloat(price);
    const t = parseFloat(tax);
    if (!isNaN(p)) {
      let final = !isNaN(t) ? p + (p * t) / 100 : p;
      return final.toFixed(2);
    }
    return "";
  };

  const calculateBreakdown = () => {
    const p = parseFloat(price);
    const c = parseFloat(commission);
    const t = parseFloat(tax);

    if (isNaN(p)) return { owner: "", affiliate: "", taxAmt: "" };

    const commissionAmt = !isNaN(c) ? (p * c) / 100 : 0;
    const taxAmt = !isNaN(t) ? (p * t) / 100 : 0;
    const ownerAmt = p - commissionAmt; // owner only gets base minus commission

    return {
      owner: ownerAmt.toFixed(2),
      affiliate: commissionAmt.toFixed(2),
      taxAmt: taxAmt.toFixed(2),
    };
  };

  const { owner, affiliate, taxAmt } = calculateBreakdown();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setLoading(true);
    try {
      await axiosClient.post("/api/option", {
        option_name: "pricing",
        option_value: JSON.stringify({ price, commission, tax }),
        autoload: true,
      });
      setMessage("✔️ Saved successfully.");
    } catch (error) {
      setMessage("❌ Error saving data.");
    } finally {
      setLoading(false);
    }
  };

  if (initialLoading) {
    return <div className="container mt-4">Loading...</div>;
  }

  return (
    <div className="container">
      <div className="d-flex align-items-center justify-content-start mb-4">
        <h3 className="mb-0 me-3">Pricing</h3>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="price" className="form-label">
            Price (₹)
          </label>
          <input
            type="number"
            className="form-control"
            id="price"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="commission" className="form-label">
            Affiliate Commission (%)
          </label>
          <input
            type="number"
            className="form-control"
            id="commission"
            value={commission}
            onChange={(e) => setCommission(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="tax" className="form-label">
            Tax (%)
          </label>
          <input
            type="number"
            className="form-control"
            id="tax"
            value={tax}
            onChange={(e) => setTax(e.target.value)}
          />
        </div>

        {/* Final price */}
        <div className="mb-3">
          <label className="form-label">Final Price (₹)</label>
          <input
            type="text"
            className="form-control"
            value={calculateFinalPrice()}
            readOnly
          />
        </div>

        {/* Breakdown */}
        <div className="mb-3">
          <label className="form-label">Owner Amount (₹)</label>
          <input type="text" className="form-control" value={owner} readOnly />
        </div>
        <div className="mb-3">
          <label className="form-label">Affiliate Amount (₹)</label>
          <input
            type="text"
            className="form-control"
            value={affiliate}
            readOnly
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Tax Amount (₹)</label>
          <input type="text" className="form-control" value={taxAmt} readOnly />
        </div>

        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? "Saving..." : "Save"}
        </button>
        {message && (
          <div className="mt-3 alert alert-info" role="alert">
            {message}
          </div>
        )}
      </form>
    </div>
  );
};

export default PriceDiscountComponent;
